import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton";
import ArgonTypography from "components/ArgonTypography";

/**
 * MessageCardDashboard
 * Extends to handle a new 'chat' action type that posts a message to open the QlickAI iframe.
 */
function MessageCardDashboard({ image, text, action }) {
  const handleChatOpen = () => {
    // Send a message to the window listener in index.html
    window.postMessage("openChat", "*");
  };

  return (
    <Card>
      <ArgonBox p={2}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={4}>
            <ArgonBox
              sx={{
                position: "relative",
                width: "100%",
                paddingTop: "100%",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: 3,
              }}
            >
              <video
                src="https://qlickup.it/wp-content/uploads/2025/04/globe.mp4"
                autoPlay
                muted
                loop
                playsInline
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </ArgonBox>
          </Grid>

          <Grid item xs={8}>
            <ArgonBox>
              <ArgonTypography variant="h6" fontWeight="medium">
                Chiedi a QlickAI
              </ArgonTypography>
            </ArgonBox>
            <ArgonBox mb={2} lineHeight={1.1}>
              <ArgonTypography variant="button" color="text" sx={{ fontWeight: "400" }}>
                {text}
              </ArgonTypography>
            </ArgonBox>
            {action && (
              <>
                {action.type === "internal" && (
                  <ArgonButton
                    component={Link}
                    to={action.route}
                    color={action.color}
                    variant="gradient"
                    size="small"
                  >
                    {action.label}
                  </ArgonButton>
                )}

                {action.type === "external" && (
                  <ArgonButton
                    component="a"
                    href={action.route}
                    target="_blank"
                    rel="noreferrer"
                    color={action.color}
                    variant="gradient"
                    size="small"
                  >
                    {action.label}
                  </ArgonButton>
                )}

                {action.type === "chat" && (
                  <ArgonButton
                    color={action.color}
                    variant="gradient"
                    size="small"
                    onClick={handleChatOpen}
                  >
                    {action.label}
                  </ArgonButton>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </ArgonBox>
    </Card>
  );
}

MessageCardDashboard.propTypes = {
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  action: PropTypes.shape({
    type: PropTypes.oneOf(["external", "internal", "chat"]).isRequired,
    route: PropTypes.string.isRequired,
    color: PropTypes.oneOf([
      "default",
      "primary",
      "secondary",
      "info",
      "warning",
      "error",
      "light",
      "dark",
    ]).isRequired,
    label: PropTypes.string.isRequired,
  }),
};

MessageCardDashboard.defaultProps = {
  action: null,
};

export default MessageCardDashboard;
